import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { default as Actions } from '../actions';
import * as CommonActions from '../../common/actions';
import { default as ActionCable } from '../../utilities/actionCable';

import './Home.scss';

import { BrandBand, ErrorModal } from '../../common/components';
import {
  Header,
  ImportList,
  ImportProfileWizard,
  McMenu
} from '../components/';
import * as Util from '../../common/utilities';

export class ProfileDashboard extends Component {
  componentDidMount() {
    this.fetchProfiles();
    this.props.actions.getRules();
    this.actionCable = new ActionCable('metalMastodon', 'ecs/cable');
    this.actionCable.subscribe(
      'ImportWorkerChannel',
      {},
      this.onReceived.bind(this)
    );
  }

  componentDidUpdate(prevProps) {
    if (
      Util.propChanged(
        prevProps,
        this.props,
        'imports.data.lastDeImport',
        'error'
      ) ||
      Util.propChanged(
        prevProps,
        this.props,
        'imports.data.lastDeImport',
        'complete_with_error'
      )
    ) {
    }
  }

  onReceived(data) {
    this.fetchProfiles();
  }

  fetchProfiles() {
    const options = { ...this.props.location.query };
    this.props.actions.getImports(options);
  }

  openProfileImportDialog(isScheduled) {
    const data = { isScheduled };
    if (!isScheduled) {
      data.currentStep = 'step1';
    }
    this.props.actions.getDataExtensions();
    this.props.actions.openModal('profileImport', data);
  }

  handleDetailsClick(profile) {
    this.props.actions.openModal('profileErrors', profile.status_errors || []);
  }

  render() {
    return (
      <McMenu
        flags={this.props.flags}
        history={this.props.history}
        route="/attributes/asset"
      >
        <BrandBand>
          <Header route={this.props.match} />
          <ImportList
            actions={this.props.actions}
            imports={this.props.imports}
            onImportProfileClick={this.openProfileImportDialog.bind(this)}
            onDetailsClick={this.handleDetailsClick.bind(this)}
            location={this.props.location}
          />
          <ImportProfileWizard
            actions={this.props.actions}
            dataExtensions={this.props.dataExtensions}
            modals={this.props.modals}
            location={this.props.location}
            maxAttributes={30}
          />
          <ErrorModal
            actions={this.props.actions}
            modals={this.props.modals}
            modalName="profileErrors"
            title="components.ecs.profiles.errors.title"
          />
        </BrandBand>
      </McMenu>
    );
  }
}

ProfileDashboard.contextTypes = {
  router: PropTypes.object
};

ProfileDashboard.propTypes = {
  actions: PropTypes.shape({
    getDataExtensions: PropTypes.func,
    getDataExtensionColumns: PropTypes.func,
    getDataExtensionRows: PropTypes.func,
    getProfiles: PropTypes.func,
    getRules: PropTypes.func,
    openModal: PropTypes.func,
    saveRules: PropTypes.func
  }),
  dataExtensions: PropTypes.object,
  flags: PropTypes.object,
  forms: PropTypes.object,
  rules: PropTypes.object,
  imports: PropTypes.object.isRequired,
  modals: PropTypes.object,
  location: PropTypes.object
};

function mapStateToProps(state) {
  return {
    dataExtensions: state.ecs.dataExtensions,
    flags: state.ecs.flags,
    forms: state.forms,
    modals: state.modals,
    imports: state.ecs.imports,
    rules: state.ecs.rules
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...Actions, ...CommonActions }, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ProfileDashboard);
